<div class="chat-backdrop" [class.visible]="isChatbotMaximized" (click)="onMinimizeChatbot()"></div>
<div
  class="chat-iframe-container"
  [class.hidden]="!isChatbotVisible"
  [class.maximized]="isChatbotMaximized"
  [style.left.px]="!isChatbotMaximized ? chatbotPosition.x : null"
  [style.top.px]="!isChatbotMaximized ? chatbotPosition.y : null"
  [style.right]="!isChatbotMaximized ? 'unset' : null"
  [style.bottom]="!isChatbotMaximized ? 'unset' : null"
  (mousedown)="onDragStart($event)">
  <div class="chat-drag-handle"></div>
  @if (requiresCopilotSignIn) {
  <div class="copilot-signin-overlay">
    <span class="copilot-signin-text">Sign in with your Microsoft account to use M365 Copilot.</span>
    <button class="copilot-signin-btn" type="button" [disabled]="copilotSignInBusy" (click)="signInToCopilot()">
      {{ copilotSignInBusy ? 'Signing in…' : 'Sign in with Microsoft' }}
    </button>
    @if (copilotSignInError) {
    <span class="copilot-signin-error">{{ copilotSignInError }}</span>
    }
  </div>
  }
  <iframe [src]="chatbotUrl" frameborder="0" class="chat-iframe"></iframe>
</div>
